module.exports = __webpack_public_path__ + "images/emoji/name_badge.26726b31af39ddaf90fc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/name_badge.png
// module id = B9Cr
// module chunks = 14